import React from 'react'

export const Crementer = ({label, wrapperClass, increment, decrement, value, incrementClass, decrementClass, valueClass}) => {
  return (
    <div>
      { label && <label> { label } </label> }
      <div className={wrapperClass}>
        <div onClick={decrement} className={decrementClass}>
          <div>
            <h2 className={'demarginify'}> - </h2>
          </div>
        </div>
        <div className={valueClass}>
          { value }
        </div>
        <div onClick={increment} className={incrementClass}>
          <div>
            <h2 className={'demarginify'}> + </h2>
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/NumberCrementer.jsx